/**
 * Trigger a browser download for a Blob. Creates a temporary anchor element,
 * clicks it, and revokes the object URL. Idempotent and safe to call from
 * event handlers.
 */
const downloadBlob = (blob: Blob, filename: string): void => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export default downloadBlob;
